import {delay} from "redux-saga"
import {call, all, put, select, takeEvery} from "redux-saga/effects"
import {push} from "redux-little-router"

import api from "../../services/ApiService"
import {AppCreators as Creators} from "./redux"
import {AppTypes as Types} from "./redux"
import {LoginCreators} from "../Login/redux"
import {checkEnv, cookie, log} from "../../utils"
import {vars} from "../../config"
import i18n from "../../utils/i18n"

export default function* fetchMenus(dispatch) {
  const state = yield select()
  const lang = state.app.lang

  yield takeEvery(Types.REFRESH_TOPICS_REQUEST, fetchTopics, dispatch)

  try {
    const [
      mainMenuResponse,
      footerMenuResponse,
      topicMenuResponse,
      sidebarMenuResponse,
      numBookmarksResponse,
      faqResponse
    ] = yield all([
      call(api.getMenuBySlug, "main", lang),
      call(api.getMenuBySlug, "footer", lang),
      checkEnv("DISABLE_LEARNING")
        ? call(() => [])
        : call(api.getLearningThemes, lang),
      call(api.getSidebar, lang),
      call(api.getBookmarksNumber, lang),
      checkEnv("DISABLE_FAQ_FLYOUT", true)
        ? call(() => [])
        : call(api.getFAQCategoriesAndArticles, lang)
    ])

    yield put(
      Creators.success(
        mainMenuResponse,
        footerMenuResponse,
        topicMenuResponse,
        sidebarMenuResponse,
        numBookmarksResponse.num_bookmarks,
        faqResponse
      )
    )
  } catch (e) {
    yield put(Creators.error(e.message))
  }
}

export function* fetchTopics() {
  const state = yield select()
  const lang = state.app.lang
  try {
    const [mainMenuResponse, topicMenuResponse] = yield all([
      call(api.getMenuBySlug, "main", lang),
      call(api.getLearningThemes, lang)
    ])
    yield put(
      Creators.refreshTopicsSuccess(mainMenuResponse, topicMenuResponse)
    )
  } catch (e) {
    yield put(Creators.error(e.message))
  }
}

export function* fetchNotifications() {
  const state = yield select()
  const lang = state.app.lang

  // cancel fetching, when there is no token
  if (!state.login.token || checkEnv("DISABLE_NOTIFICATIONS")) {
    return
  }

  try {
    const response = yield call(api.getNotifications, lang, 5, 0)

    yield put(
      Creators.setNotifications(response.notifications, response.unread_count)
    )
  } catch (e) {
    yield log.dev("Could not fetch notifications")
    yield log.dev(e)
  }

  // fetch again after timeout
  yield delay(vars.notifications.refreshTimeout)
  yield put(Creators.fetchNotifications())
}

export function* readNotification(_dispatch, {id}) {
  try {
    const response = yield call(api.readNotification, id)

    yield put(Creators.readNotificationSuccess(response.read_at, response.id))
  } catch (e) {
    yield log.dev("Notification could not be marked as read")
    yield log.dev(e)
  }
}

export function* readAllNotifications(_dispatch, _action) {
  try {
    const response = yield call(api.readAllNotifications)

    yield put(Creators.readNotificationsAllSuccess(response.read_at))
  } catch (e) {
    yield log.dev("Notifications could not be marked as read")
    yield log.dev(e)
  }
}

export function* forceLogout(dispatch, action) {
  const state = yield select()
  const lang = state.app.lang
  const referrer = state.router.pathname

  if (/_ERROR/g.test(action.type)) {
    switch (action.error) {
      case "jwt_auth_invalid_token: Expired token":
      case "jwt_auth_invalid_token: Invalid signature encoding":
      case "jwt_auth_invalid_token: Signature verification failed":
      case "jwt_auth_no_auth_header: Authorization header not found.":
      case "jwt_auth_bad_auth_header: Authorization header malformed.":
      case "jwt_auth_bad_iss: The iss do not match with this server":
      case "jwt_auth_bad_request: User ID not found in the token":
      case "jwt_auth_failed: Invalid Credentials.":
        dispatch(LoginCreators.logout()) // trigger logout

        if (!/login(\/?)$/g.test(referrer)) {
          // // set referrer as cookie for 5 minutes
          cookie.set("referrer", referrer, 0.003472222)

          // forward to login page
          yield dispatch(
            push(`/${lang}/login?revalidate=1&referrer=${encodeURI(referrer)}`)
          )
        }
        break

      default:
    }
  }
}

export function* addTracking(_dispatch, {data, tag}) {
  // use matamo data array, otherwise create it
  window[tag] = window[tag] || []

  // push data to matomo tracking
  yield window[tag].push(data)

  // trigger tracking added action
  yield put(Creators.trackingAdded(data, tag))
}

export function* shouldChangeDocumentTitle(dispatch, {data}) {
  if (typeof data.document_title !== "undefined") {
    yield call(changeDocumentTitle, dispatch, {title: data.document_title})
  }
}

export function* changeDocumentTitle(_dispatch, {title}) {
  const parser = new DOMParser()
  const newTitle = parser.parseFromString(
    `<!doctype html><body>${title}${vars.titleSeparator}${i18n.t(
      vars.titleSiteName
    )}`,
    "text/html"
  ).body.textContent

  // change document title
  yield (document.title = newTitle)

  // trigger changed title action
  yield put(Creators.changedTitle(newTitle))
}



// WEBPACK FOOTER //
// ./src/containers/App/sagas.js